<template>
  <div>
    <PolarBar :centerX="28" :chartData="chartData" :barWidth="12"/>
  </div>
</template>

<script>
import PolarBar from "@/components/Echarts/PolarBar.vue";

export default {
  name: "YuleZiyuanFenxi",
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    PolarBar
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
